//@flow
import React from 'react'
import { Details, FieldCollection } from 'src/components/Form'
// $FlowFixMe
import { FormSection } from 'redux-form'

import { InfoRibbon } from '../StyledElements'
import { StyledP, Title } from 'src/theme/globalStyle'

export const ShowGurantorText = (income: number) => {
  return (
    <FieldCollection hasShadow noPadding>
      <FormSection name="guarantor">
        <Title lessMargin isPadded>
          About Your Guarantor
        </Title>
        <StyledP isPadded style={{ width: '85%' }}>
          {`In order to apply for this room, you will need to supply us with a guarantor who earns
                    over £${income} per annum. Please enter their details below.`}
        </StyledP>
        <InfoRibbon>
          <StyledP isPadded>
            The guarantor needs to be a UK based citizen and have a UK address
          </StyledP>
        </InfoRibbon>
        <Details isGuarantor isPadded />
      </FormSection>
    </FieldCollection>
  )
}



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/GurantorText.js